const buttonData = [
    {id: "clear", name: "clear"},
    {id: "seven", name: "7"},
    {id: "eight", name: "8"},
    {id: "nine", name: "9"},
    {id: "add", name: "+"},
    {id: "four", name: "4"},
    {id: "five", name: "5"},
    {id: "six", name: "6"},
    {id: "subtract", name: "-"},
    {id: "one", name: "1"},
    {id: "two", name: "2"},
    {id: "three", name: "3"},
    {id: "multiply", name: "x"},
    {id: "zero", name: "0"},
    {id: "decimal", name: "."},
    {id: "equals", name: "="},
    {id: "divide", name: "/"},
]

export default buttonData;